import { render } from "./PreviewImg.vue?vue&type=template&id=a15da950&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=js"
export * from "./PreviewImg.vue?vue&type=script&lang=js"

import "./PreviewImg.vue?vue&type=style&index=0&id=a15da950&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15da950"]])

export default __exports__